export const config = {
  eventGroup: 'jx2_ysxf_zlp_pc_20260924',
  name: '《剑网2》26年9月云水相逢资料片',
  identify: 'jx2',
  eventTags: ['jx2', 'pc', 'zlp']
};

export default function createTracker(report, getDiffRouteTime) {
  return {
    loadPage: function() {
      report({
        eventName: 'load_page',
        eventDescription: '页面加载(默认上报，页面全部加载完才上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    pageLeave: function() {
      report({
        eventName: 'page_leave',
        eventDescription: '离开页面(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageStart: function() {
      report({
        eventName: 'load_page_start',
        eventDescription: '页面加载(默认上报，进入页面就上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    /**
     * @param {string} [title] - 上报子功能名称：跨服夺宝，赛季争锋；兵魄拓境，武运精进；星玉焕新，战力腾跃；华章共书，万侠登峰；金秋同庆，群侠共聚；周年新服，再赴侠缘
     * @param {string} [kinds] - 上报点击位置：首页子功能按钮；内页子功能导航
     */
    clickSubFunctionButton: function(title, kinds) {
      report({
        eventName: 'click_sub_function_button',
        eventDescription: '点击资料片专题子功能按钮',
        eventDataValue: {
          title: title,
          kinds: kinds
        },
        types: {
          title: checkTypeHOF('string'),
          kinds: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报活动子导航名称：山河同庆会；万家灯火照长夜；玉兔闹月庭；月满百味坊；九州纪行册；山河百炼彩匣；茱萸合香录；周年大赠送；周年大回馈；周年彩蛋；周年礼包；周年装饰兑换；充值抽奖拼手气；盛典欢乐购；特价脉气包；幸运双倍掉落；幸运百宝箱
     */
    clickActivitySubnav: function(title) {
      report({
        eventName: 'click_activity_subnav',
        eventDescription: '点击活动内页子导航',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
